import { render, staticRenderFns } from "./loadingCard.vue?vue&type=template&id=35f3dd38&"
import script from "./loadingCard.vue?vue&type=script&lang=js&"
export * from "./loadingCard.vue?vue&type=script&lang=js&"
import style0 from "./loadingCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/proyectos/rosalinda-store/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VCard,VProgressCircular})
